export default "__VITE_ASSET__$0hGMTNT__"